"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

var FeatureListItem = function FeatureListItem(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'lg' : _ref$variant,
      text = _ref.text,
      subText = _ref.subText,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === void 0 ? 'done' : _ref$iconName;
  return /*#__PURE__*/_react["default"].createElement(_.Flex, null, /*#__PURE__*/_react["default"].createElement(_.Icon, {
    size: 24,
    name: iconName
  }), /*#__PURE__*/_react["default"].createElement(_.Flex, {
    flexDirection: "column",
    ml: "4"
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    fontSize: variant === 'lg' ? 'lg' : 'base'
  }, text), subText && /*#__PURE__*/_react["default"].createElement(_.Text, {
    fontSize: "xs",
    color: "greys.steel"
  }, subText)));
};

FeatureListItem.propTypes = {
  text: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].oneOf(['lg', 'sm']),
  subText: _propTypes["default"].string,
  iconName: _propTypes["default"].string
};
var _default = FeatureListItem;
exports["default"] = _default;